import { Component, OnInit } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { MunicipalityService } from '@app/shared/services/api/municipality.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { environment } from '@env/environment';
import { distinctUntilChanged, filter, first } from 'rxjs/operators';
import { MapStoreMunicipality } from '@app/shared/models/municipality/Municipality';

@Component({
  selector: 'app-storungen',
  templateUrl: './storungen.component.html',
  styleUrls: ['./storungen.component.scss'],
})
export class StorungenComponent implements OnInit {
  url?: SafeResourceUrl;
  tenant!: string;
  isIE11!: boolean;

  constructor(
    public sanitizer: DomSanitizer,
    public overlayLoaderService: OverlayLoaderService,
    public municipalityService: MunicipalityService,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {}

  ngOnInit() {
    this.isIE11 = !!(window as any).MSInputMethodContext && !!(document as any).documentMode;
    this.tenant = environment.tenant.trim().toLowerCase();
    this.userMunicipalitiesService.currentMunicipality$
      .pipe(
        filter((municipality: MapStoreMunicipality) => !!municipality?.guid && !!municipality?.key),
        distinctUntilChanged(),
        first()
      )
      .subscribe((municipality: MapStoreMunicipality) => {
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(environment.storungenUrl + municipality.postCode);
      });
  }
}
